import { IAppointmentScheduleResponse, IPatientDetail } from "@curefit/care-common";
import { MaskNumber } from "@curefit/care-rangoon-integration";
import * as _ from "lodash";
import * as moment from "moment";
import * as React from "react";
import { connect } from "react-redux";
import ForceCloseConsultationWrapper from "../../components/ForceCloseConsultationWrapper";
import { IAppState } from "../../models/IAppState";
import { IOngoingProductInfo } from "../../models/IOngoingConsultationSellableProduct";
import { RouteUtils } from "../../routes";
import { ForceCloseReason, AppConstants, PrescriptionTabModes } from "../../utils/AppConstants";
import { default as AppUtils } from "../../utils/AppUtils";
import { EventNames } from "../../utils/EventTrackerConstants";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import Timer from "../../components/Timer";
import ConsultationUtils from "../../utils/ConsultationUtils";

export interface TopBannerProps {
  patient: IPatientDetail;
  patientProfile: IPatientDetail;
  baseSellableProduct: IOngoingProductInfo;
  appointmentSchedule: IAppointmentScheduleResponse;
  TabsComponent: JSX.Element;
  onTimerAlarm?: (flag: boolean, time: number) => void;
  renderOptions: { timer: boolean, phoneCall: boolean, showBack?: boolean, backActionHandler?: () => void };
  forceCompleteAppointment?: (
    status: string,
    reasonCode: ForceCloseReason,
    reasonText: string
  ) => void;
  toggleOngoingContainerVisiblility?(): void
  prescriptionMode?: PrescriptionTabModes;
  appointmentId?: number;
  patientPhoneNumber?: string;
}

export interface TopBannerState {
  shouldShowforceCloseModal: boolean;
}

type StateProps = ReturnType<typeof mapStateToProps>

type Props = StateProps & TopBannerProps

class TopBannerComponent extends React.Component<Props, TopBannerState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      shouldShowforceCloseModal: false
    }
    this.toggleForceCloseModal = this.toggleForceCloseModal.bind(this);

  }
  toggleForceCloseModal() {
    LocalStorageUtils.setClickEvents({ field: EventNames.Exit_Consultation, section: EventNames.Exit_Consultation, widget: EventNames.Exit_Consultation })
    this.setState({
      shouldShowforceCloseModal: !this.state.shouldShowforceCloseModal
    });

    //  fix for ios issue where force close modal is not visible
    this.props.toggleOngoingContainerVisiblility();

  }

  render() {
    const { shouldShowforceCloseModal } = this.state;
    const currPatient = this.props.patient;
    const isMobile = AppUtils.getIsMobile();
    const patientAge =
      AppUtils.getFormattedAgeToDisplay(this.props.patientProfile.formattedAge);
    const patientGender = (!_.isEmpty(currPatient.gender) ? " " + currPatient.gender : "");
    // const sellableProductInfo = this.props.baseSellableProduct;
    const city = !_.isEmpty(this.props.appointmentSchedule.cityCode)
      ? this.props.appointmentSchedule.cityCode
      : null;
    const consultationDurationTxt =
      moment(this.props.appointmentSchedule.startTime).format("HH.mm a") +
      "-" +
      moment(this.props.appointmentSchedule.endTime).format("HH.mm a");
    const followupConsultationId =
      !_.isNull(this.props.appointmentSchedule) &&
        !_.isNull(this.props.appointmentSchedule.followUpConsultationId) &&
        this.props.appointmentSchedule.followUpConsultationId !== -1
        ? this.props.appointmentSchedule.followUpConsultationId
        : null;
    const consultationMode =
      this.props.appointmentSchedule &&
      this.props.appointmentSchedule.consultationProduct &&
      this.props.appointmentSchedule.consultationProduct.consultationMode;
    const TabsComponent = this.props.TabsComponent;
    const sellableProductInfo = this.props.baseSellableProduct;
    const packInfo = this.props.prescriptionMode === PrescriptionTabModes.ONGOING && this.props.appointmentSchedule && this.props.appointmentSchedule.packInfo && ConsultationUtils.getPackDetails(this.props.appointmentSchedule);
    const showBack = this.props.renderOptions.showBack;
    const ConsultationInfoChildren = (
      <>
        <div>
          {/* {AppUtils.isDefined(sellableProductInfo) && (
            <div className={"consultation-info"}>
              <span className={"consultation-root-booking-name"}>
                {sellableProductInfo.productName}
              </span>
            </div>
          )} */}
          {/* <div className="consultation-info">
            <span className="consultation-duration">
              {consultationDurationTxt}
            </span>
          </div> */}
          {!_.isNull(followupConsultationId) && (
            <div className="consultation-info">
              |{" "}
              <a
                target={"_blank"}
                href={RouteUtils.getPatientConsultationDetailsUrl(
                  currPatient.id,
                  followupConsultationId
                )}
                className={"follow-up-link"}
              >
                Follow up
            </a>
            </div>
          )}
          {/* {this.props.renderOptions && this.props.renderOptions.timer && (
            <div className={"elapsed-time"}>
              <Timer
                alarm={AppConstants.CONSULTATION_DELAY_HOOKS_IN_MINUTES}
                callBackOnAlarm={time => this.props.onTimerAlarm(true, time)}
              />
            </div>
          )} */}
        </div>
      </>
    );

    return (
      <div>
        <div className="ongoing-consultation-topnav">
          <section className="ongoing-consultation-topnav-left" style={{ gridTemplateColumns: `${showBack ? '25px' : ''} 1fr 0.5fr 1fr` }}>
            {!isMobile && showBack && <img src="/images/back-arrow.svg" alt="back" onClick={this.props.renderOptions.backActionHandler} style={{ cursor: 'pointer' }} />}
            {!isMobile && <div className="patient-info">
              <div className="patient-name">
                {currPatient.name}
                {(
                  <>
                    <img className="patient-info-icon" src="/images/icons/info-grey.svg" />
                    <div className="patient-info-additional-details">
                      <div className="patient-info-additional-details-row">UHID: {currPatient.uhid}</div>
                      <div className="patient-info-additional-details-row">{sellableProductInfo && sellableProductInfo.productName}</div>
                      <div className="patient-info-additional-details-row">{consultationDurationTxt}</div>
                      {/* <div className="patient-info-additional-details-row">{this.props.renderOptions && this.props.renderOptions.timer && (
                        <Timer
                          alarm={AppConstants.CONSULTATION_DELAY_HOOKS_IN_MINUTES}
                          callBackOnAlarm={time => this.props.onTimerAlarm(true, time)}
                        />
                      )}
                      </div> */}
                      {
                        packInfo && <div className="patient-info-additional-details-row">
                          <div className="appointment-pack-info">
                            <div>Sessions Booked</div>
                            <div><span className="brandon-bold">{packInfo.totalTicketsConsumed}</span> of {packInfo.totalTickets}</div>
                          </div>
                          <div className="appointment-pack-info">
                            <div>Pack Expiry</div>
                            <div><span className="brandon-bold">{AppUtils.getRelativeDay(packInfo.startEndEpoch.endEpoch, "D MMM Y")}</span></div>
                          </div>
                        </div>
                      }
                    </div>
                  </>
                )}
              </div>
              <div className="patient-gender-age">
                {patientAge} <span className="patient-gener-age-separator">&nbsp;|&nbsp;</span> {patientGender} <span className="patient-gener-age-separator">&nbsp;|&nbsp;</span> {city}
              </div>
            </div>}
            {isMobile && (
              <div className="patient-info-mobile">
                <div className={"patient-details"}>
                  <div className={"patient-name"}>{currPatient.name}</div>
                  <div className={"patient-meta"}>
                    <span>{currPatient.age} {currPatient.gender}{" "}</span>
                    <div>
                      <span className="age-city-separator">&#x25cf;</span>
                      <span>{city}</span>
                    </div>
                  </div>
                  <div className={"patient-meta"}>{`${isMobile ? "UHID: " : ""}${currPatient.uhid}`}</div>
                </div>
                <div className="exit-cons-wrapper" onClick={this.toggleForceCloseModal}>
                  <img src="/images/icons/cross-red-cirlce.svg" />
                  <span>Exit Consultation</span>
                </div>
              </div>
            )}

            {this.props.renderOptions &&
              this.props.renderOptions.phoneCall &&
              !isMobile && (
                <div className={"call-patient-container"}>
                  {this.props.updatedPatientPhoneNumber && (
                    <MaskNumber
                      phoneNumber={"Call Patient"}
                      receiverPhoneNumber={this.props.updatedPatientPhoneNumber}
                      shouldShowNumber
                      meta={{ appointmentId: this.props.appointmentId && this.props.appointmentId.toString() }}
                    />
                  )}
                  {!this.props.updatedPatientPhoneNumber && (
                    <MaskNumber
                      phoneNumber={"Call Patient"}
                      receiverPhoneNumber={this.props.patientPhoneNumber}
                      shouldShowNumber
                      meta={{ appointmentId: this.props.appointmentId && this.props.appointmentId.toString() }}
                    />
                  )}
                </div>
              )}

            {!isMobile &&
              <div className="outside-timer">
                <span className="field-name">Time Elapsed : </span>
                {this.props.renderOptions && this.props.renderOptions.timer && (
                  <Timer
                    alarm={AppConstants.CONSULTATION_DELAY_HOOKS_IN_MINUTES}
                    callBackOnAlarm={time => this.props.onTimerAlarm(true, time)}
                    format="text"
                    customCss={{ fontFamily: 'BrandonTextWeb-Bold' }}
                  />
                )}
              </div>
            }
            {isMobile ? (
              <div className="consultation-info-container">
                {ConsultationInfoChildren}
              </div>
            ) : (
              ConsultationInfoChildren
            )}
          </section>
          <div className={"prescription-auto-save-icon hidden"}>
            <span className={"glyphicon glyphicon-floppy-open"} />
          </div>
          {TabsComponent ? TabsComponent : null}
          {this.props.forceCompleteAppointment && (
            <ForceCloseConsultationWrapper
              forceCompleteAppointment={this.props.forceCompleteAppointment}
              consultationMode={consultationMode}
              shouldShowforceCloseModal={shouldShowforceCloseModal}
              toggleForceCloseModal={this.toggleForceCloseModal}
            />
          )}
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state: IAppState) => {
  return {
    updatedPatientPhoneNumber:
      state.overrides && state.overrides.patientPhoneNumber,
    appointmentId: _.get(state, 'ongoingConsultation.appointmentSchedule.id', null),
    patientPhoneNumber: _.get(state, 'ongoingConsultation.appointmentSchedule.appointmentActionsWithContext.audioActionWithContext.context.twilioCommunicationMode.modeName', null)
  };
};

export default connect<StateProps, null, TopBannerProps>(mapStateToProps)(TopBannerComponent);
